import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLang } from "../i18n";

const KEY = "mdc-cookie-consent";

const applyConsent = (value) => {
    const ph = window.posthog;
    if (!ph) return;
    if (value === "accepted" && typeof ph.opt_in_capturing === "function") {
        ph.opt_in_capturing();
    } else if (value === "rejected" && typeof ph.opt_out_capturing === "function") {
        ph.opt_out_capturing();
    }
};

const CookieBanner = () => {
    const [consent, setConsent] = useState(() => localStorage.getItem(KEY));
    const { t } = useLang();

    useEffect(() => {
        applyConsent(consent);
    }, [consent]);

    const choose = (value) => {
        localStorage.setItem(KEY, value);
        setConsent(value);
    };

    return (
        <AnimatePresence>
            {!consent && (
                <motion.div
                    data-testid="cookie-banner"
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 40 }}
                    transition={{ duration: 0.5, delay: 1.2, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed bottom-4 left-4 right-4 z-[70] sm:left-auto sm:max-w-md"
                    role="dialog"
                    aria-live="polite"
                >
                    <div className="rounded-[1.5rem] border border-[#E3DCCF] bg-white/95 p-5 shadow-2xl shadow-ink/15 backdrop-blur">
                        <div className="flex items-start gap-3">
                            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-terracotta/10 text-terracotta">
                                <Cookie size={17} />
                            </span>
                            <p className="text-[13px] leading-relaxed text-[#525B53]">
                                {t.cookie.text}{" "}
                                <Link to="/cookies" className="font-semibold text-terracotta underline-offset-2 hover:underline">
                                    {t.cookie.more}
                                </Link>
                            </p>
                        </div>
                        <div className="mt-4 flex gap-2.5">
                            <button
                                data-testid="cookie-reject"
                                onClick={() => choose("rejected")}
                                className="flex-1 rounded-full border border-[#E3DCCF] px-4 py-2.5 text-[13px] font-bold text-[#525B53] transition-colors hover:bg-sand/50"
                            >
                                {t.cookie.reject}
                            </button>
                            <button
                                data-testid="cookie-accept"
                                onClick={() => choose("accepted")}
                                className="flex-1 rounded-full bg-terracotta px-4 py-2.5 text-[13px] font-bold text-cream transition-colors hover:bg-terracotta-dark"
                            >
                                {t.cookie.accept}
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CookieBanner;
